import moment from 'moment';
import React from 'react'
import { MoneyLogCell } from '../../../../../components/MoneyLogLines'

export const TableRow = (props) => {
  const { id, value, user, account, createdAt, methodId, thirdPartyTransId, referenceNumber, fee, total, handleFee, chargedBy, chargeUser, chargeType, moneyLog } = props;

  const chargeByName = chargedBy?.name || chargeUser?.name || ''
  const chargeByUsername = chargedBy?.username || chargeUser?.username || ''
  const displayChargeBy = chargeType === 'MANUAL' && (chargeByName || chargeByUsername)
    ? `${chargeByName}${chargeByUsername ? ` (${chargeByUsername})` : ''}`
    : (chargeType === 'AUTO' ? 'Auto system' : '')

  return (
    <tr>
      <td>
        {(user && user.name) || ""}<br />
        <span><strong className={`text-primary`}>{(user && user.phone.replace('+84', '0')) || ""}</strong></span>
      </td>

      {methodId === 'BANKING' ? <td>
        <img alt='' src={account.bank.logo} className="img-thumbnail" width={100} height={30}></img>
      </td>
        :
        <td>
          {methodId}
        </td>
      }
      <td className="fw-900 text-success text-right">{new Intl.NumberFormat('vn-VI', {}).format(value) || ""}</td>
      <td className="fw-900 text-success text-right">{new Intl.NumberFormat('vn-VI', {}).format(fee) || ""}</td>
      <td className="fw-900 text-success text-right">{new Intl.NumberFormat('vn-VI', {}).format(handleFee) || ""}</td>
      <td className="fw-900 text-success text-right">{new Intl.NumberFormat('vn-VI', {}).format(total) || ""}</td>
      <td>{thirdPartyTransId || referenceNumber || ''}</td>
      <td>{displayChargeBy}</td>
      <MoneyLogCell moneyLog={moneyLog} expectedType="TransactionCharge" expectedId={id} />
      <td className="text-center">{moment(createdAt || '').format('DD/MM/YYYY HH:mm:ss')}</td>
    </tr>
  );
};
